// extracted by mini-css-extract-plugin
export default {"title":"VideoDescription_title__FU0VA","bulletPoint":"VideoDescription_bulletPoint__0FvMZ","icon":"VideoDescription_icon__Od4CF"};